import { Col, Row } from 'ia-react-core';
import React, { FC } from 'react';
import { Pagination } from '../../../../interfaces/Pagination';
import DeleteButton from '../../DeleteButton';
import Navigation from '../Details/Navigation';
import { StyledLeftCol, StyledRightCol } from './ActionBar.styles';

export interface ActionBarProps {
  messageId: number;
  pagination: Pagination;
}

const ActionBar: FC<ActionBarProps> = ({ messageId, pagination }) => {
  if (messageId === 0) return null;

  return (
    <Row justify="between">
      <StyledLeftCol m-t-md={0} xs={12} sm={6} md="content">
        <DeleteButton messageId={messageId} />
      </StyledLeftCol>
      <StyledRightCol m-t-md={0} sm={6} md="content">
        <Row justify="around">
          <Col xs="content">
            {pagination && <Navigation pagination={pagination} />}
          </Col>
        </Row>
      </StyledRightCol>
    </Row>
  );
};

export default ActionBar;
